import * as React from 'react';
import { PrivateRoutes } from '../navigation/Routes';
import styled from 'styled-components';
import { ChevronRight } from 'react-feather';
import { withRouter, RouteComponentProps } from 'react-router';

import { H4 } from '../typography';
import { withBreadcrumbs } from '../utils/withBreadcrumbs';
import { ThemeInterface } from '../theme/ThemeInterface';
import { CleanNavLink } from './CleanNavLink';
import { SteynCityContext } from './ContextProvider';

const StyledChevron = styled(ChevronRight)<any>`
  margin: 1px 3px 0 6px;
  color: ${(props: ThemeInterface) => props.theme.colors.white};
`;

const StyledLink = styled(CleanNavLink)`
  display: flex;
  align-items: center;
  text-decoration: none;
  justify-content: center;
`;

type BreadCrumb = {
  breadcrumb: string;
  match: { isExact: boolean; params: any; path: string; url: string };
  path: string;
};

type Props = RouteComponentProps & {
  breadcrumbs: Array<BreadCrumb>;
};

class Breadcrumbs extends React.Component<Props> {
  static contextType = SteynCityContext;
  context!: React.ContextType<typeof SteynCityContext>;

  getNavigationUrl = (breadcrumb: BreadCrumb) => {
    if (breadcrumb.match.url.includes('/stakeholders/')) {
      return '/stakeholders/all';
    }
    if (breadcrumb.match.url.includes('/content-management/')) {
      return '/content-management/notifications';
    }
    return breadcrumb.match.url;
  };

  render() {
    const { breadcrumbs } = this.props;
    const { breadcrumbOverride } = this.context;

    return (
      <React.Fragment>
        {breadcrumbs.map((breadcrumb: BreadCrumb, index: number) => {
          const isLast = index === breadcrumbs.length - 1;
          const label =
            isLast && breadcrumbOverride ? breadcrumbOverride : breadcrumb.breadcrumb;

          return (
            <StyledLink key={breadcrumb.path} to={this.getNavigationUrl(breadcrumb)}>
              <H4 fontWeight={300} color="white">
                {label}
              </H4>
              {index < breadcrumbs.length - 1 && <StyledChevron size={18} />}
            </StyledLink>
          );
        })}
      </React.Fragment>
    );
  }
}

export default withBreadcrumbs(PrivateRoutes)(withRouter(Breadcrumbs));



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.tsx